<script>

    export let icon = "save"
    export let type = "submit"
    export let loading = false
    export let text = 'Guardar'

</script>

<button { type } class="button is-primary" class:is-loading={loading}>
    <span class="icon"><i class="fas fa-{icon}"></i></span>
    <span>{ text }</span>
</button>